import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  profile: null,
  preferences: {},
  loading: false,
  error: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setProfile: (state, action) => {
      state.profile = action.payload;
    },
    setPreferences: (state, action) => {
      state.preferences = { ...state.preferences, ...action.payload };
    },
    setUserLoading: (state, action) => {
      state.loading = action.payload;
    },
    setUserError: (state, action) => {
      state.error = action.payload;
    },
    clearUser: (state) => {
      state.profile = null;
      state.preferences = {};
      state.error = null;
    },
  },
});

export const { setProfile, setPreferences, setUserLoading, setUserError, clearUser } = userSlice.actions;
export default userSlice.reducer;
